export const enum ApiGateway {
  FIGO = 'FIGO',
  FPNA = 'FPNA',
  REGSHIELD = 'REGSHIELD',
  DEMO = 'DEMO'
}
